import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliConsigliati');
export const actions = helper.createActions('portaliConsigliati', actionTypes);
